const requirementIds = {
    createPassword: 'create-password',
    eula: 'eula',
    setSecurityQuestions: 'set-security-questions',
    resetPassword: 'reset-password',
};

export default requirementIds;
